import { BANNERS_SERVICE } from "@/services/banners.service.js";

const state = {getBannersOutput: {}, postBannerOutput: false, putBannerOutput: false, getBannerByIdOutput: {}, deleteBannerOutput: false};

const actions = {
    getBanners({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getBannersRequest');

        BANNERS_SERVICE.getBanners(queryParams)
            .then(
                output => {
                    commit('getBannersSuccess', output);
                },
                error => {
                    commit('getBannersFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    postBanner({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postBannerRequest');

        BANNERS_SERVICE.postBanner(input)
            .then(
                output => {
                    commit('postBannerSuccess', output);
                },
                error => {
                    commit('postBannerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    putBanner({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putBannerRequest');

        BANNERS_SERVICE.putBanner(input)
            .then(
                output => {
                    commit('putBannerSuccess', output);
                },
                error => {
                    commit('putBannerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    getBannerById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getBannerByIdRequest');

        BANNERS_SERVICE.getBannerById(id)
            .then(
                output => {
                    commit('getBannerByIdSuccess', output);
                },
                error => {
                    commit('getBannerByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    deleteBanner({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteBannerRequest');

        BANNERS_SERVICE.deleteBanner(id)
            .then(
                output => {
                    commit('deleteBannerSuccess', output);
                },
                error => {
                    commit('deleteBannerFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    getBannersRequest(state) {
    },
    getBannersSuccess(state, output) {
        state.getBannersOutput = output;
    },
    getBannersFailure(state) {
        state.getBannersOutput = false;
    },

    postBannerRequest(state) {
        state.postBannerOutput = null;
    },
    postBannerSuccess(state, output) {
        state.postBannerOutput = true;
    },
    postBannerFailure(state) {
        state.postBannerOutput = false;
    },

    putBannerRequest(state) {
        state.putBannerOutput = null;
    },
    putBannerSuccess(state, output) {
        state.putBannerOutput = true;
    },
    putBannerFailure(state) {
        state.putBannerOutput = false;
    },

    getBannerByIdRequest(state) {
    },
    getBannerByIdSuccess(state, output) {
        state.getBannerByIdOutput = output;
    },
    getBannerByIdFailure(state) {
        state.getBannerByIdOutput = false;
    },

    deleteBannerRequest(state) {
        state.deleteBannerOutput = null;
    },
    deleteBannerSuccess(state, output) {
        state.deleteBannerOutput = true;
    },
    deleteBannerFailure(state) {
        state.deleteBannerOutput = false;
    },
};

export const banners = {
    namespaced: true,
    state,
    actions,
    mutations
};
